module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("404")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6fdd2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/P404.vue
// module id = 547
// module chunks = 1